export default __webpack_public_path__ + "static/media/groupIcon.70bbf15f.png";